<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="popupParams.popupTitle" width="600px" @close="close">
    <div slot="content">
      <el-steps :active="activeStep" finish-status="success">
        <el-step title="가상화 모델링 정보 입력"></el-step>
        <el-step title="스케줄 설정"></el-step>
      </el-steps>
      <!-- 1. 가상화 모델링 정보 입력 -->
      <div v-show="activeStep === 0">
        <el-form :model="formData" :rules="formRules" ref="modelingForm">
          <el-row type="flex" :gutter="15">
            <el-col :span="12">
              <el-form-item prop="virtualcenterGroupId" label="가상화센터명" v-show="false">
                <el-input v-model="formData.virtualcenterGroupId"></el-input>
              </el-form-item>
              <el-form-item prop="virtualcenterGroupName" label="가상화센터명">
                <el-input v-model="formData.virtualcenterGroupName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="hypervisorType" label="하이퍼바이저 종류">
                <el-select v-model="formData.hypervisorType" style="width: 100%" :disabled="isUpdateFlag" @change="onHypervisorSelectChange">
                  <el-option v-for="item in hypervisorTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 모델링에 필요한 정보 (vms_virtualcenter 테이블에 저장되는 정보) -->
          <div v-for="(access, index) in modelingInfos" :key="index">
            <!-- KVM의 경우, 가상화모델링 1:N 접속정보 N개 -->
            <div v-show="access.sql_type !== 'DELETE'">
              <el-form-item prop="virtualcenterUrl" label="접속정보" :rules="{ required: true, validator: validateVirtualcenterInfo, trigger: 'blur', itemIndex: index }">
                <el-col :style="{ width: formData.hypervisorType === 'KVM' ? 'calc(100% - 38px)' : '100%' }">
                  <el-input v-model="access.virtualcenterUrl" :placeholder="emptyTextType[formData.hypervisorType]" @change="onInputChange(access)"></el-input>
                </el-col>
                <el-col v-show="formData.hypervisorType === 'KVM'" class="mr-l4" style="width: 34px;">
                  <el-button v-if="index === 0" size="mini" @click="addModelingInfo()">
                    <i class="fas fa-plus" />
                  </el-button>
                  <el-button v-else size="mini" @click="deleteModelingInfo(index)">
                    <i class="fas fa-minus" />
                  </el-button>
                </el-col>
              </el-form-item>
              <el-row type="flex" :gutter="15">
                <el-col :span="12">
                  <el-form-item prop="virtualcenterManagerId" label="로그인 ID" :rules="{ required: true, validator: validateVirtualcenterLoginInfo, trigger: 'blur', itemIndex: index }">
                    <el-input v-model="access.virtualcenterManagerId" @change="onInputChange(access)"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="virtualcenterPassword" label="비밀번호" :rules="{ required: true, validator: validateVirtualcenterLoginInfo, trigger: 'blur', itemIndex: index }">
                    <el-input type="password" v-model="access.virtualcenterPassword" @change="onInputChange(access)"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- RHEV의 경우, 버전/인증서 경로/인증서 비밀번호 선택 -->
              <el-row v-if="formData.hypervisorType === 'RHEV'">
                <el-form-item prop="virtualcenterVersion" label="RHEV 버전">
                  <el-select v-model="access.virtualcenterVersion" style="width: 100%" @change="onInputChange(access)">
                    <el-option v-for="version in rhevVersions" :key="version" :label="version" :value="version"></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row v-if="formData.hypervisorType === 'RHEV'">
                <el-form-item prop="certificationPath" label="인증서 경로">
                  <el-input v-model="access.certificationPath" :readonly="true">
                    <template slot="append">
                      <el-upload :auto-upload="false" :on-change="changeCertificationPath" action="" :before-upload="(file) => file" :show-file-list="false">
                        <el-button size="small" type="primary" class="btn-upload">파일업로드</el-button>
                      </el-upload>
                    </template>
                  </el-input>
                </el-form-item>
              </el-row>
              <el-row v-if="formData.hypervisorType === 'RHEV'">
                <el-form-item prop="certificationPassword" label="인증서 비밀번호">
                  <el-input type="password" v-model="access.certificationPassword" @change="onInputChange(access)"></el-input>
                </el-form-item>
              </el-row>
            </div>
          </div>
          <!-- <el-row type="flex" :gutter="15">
            <el-col :span="12">
              <el-form-item prop="agentManagerGroupId" label="수집 서버 그룹">
                <el-input v-model="formData.virtualcenterManagerId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
          </el-row> -->
        </el-form>
      </div>
      <!-- 2. 스케줄 설정 -->
      <div v-show="activeStep === 1">
        <div class="title-bar title-h4">스케줄 등록</div>
        <div>
          <el-row type="flex">
            <div class="title-popup-s mr-r4">스케줄 활성여부</div>
            <el-switch v-model="formData.activeFlag" active-value="Y" inactive-value="N"></el-switch>
          </el-row>
          <w-vms-period-setting-component ref="periodSettingCmp" />
        </div>
      </div>
    </div>
    <el-row slot="footer" type="flex" justify="space-between">
      <div>
        <el-button size="large" v-show="activeStep === 1" @click="moveStep(activeStep, 0)"><i class="fas fa-long-arrow-left mr-r2"></i>뒤로</el-button>
      </div>
      <div>
        <el-button size="large" type="solid" v-show="activeStep === 0" @click="moveStep(activeStep, 1)">다음</el-button>
        <el-button size="large" type="solid" v-show="activeStep === 1" @click="completeModeling">완료</el-button>
        <el-button size="large" @click="close">취소</el-button>
      </div>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import { cloneDeep, isNil, isEqual, isEmpty, map, uniq } from 'lodash';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import { MONTH, WEEK, TIME, MINUTE } from '@/constants/date';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import { isUnauthorizedFile } from '@/utils/file';
import { MSG_UPLOAD_UNAUTHORIZED_FILE } from '@/constants/file';
import { getRsaEncryptBulk } from '@/utils/rsa-encrypt';
import DeviceRegistrationVmsAPI from '@/api/settings/common/device-registration-vms';
import WVmsPeriodSettingComponent from '@/views/settings/components/VmsPeriodSettingComponent';

export default {
  name: 'WModelingSettingPopup',
  components: {
    WVmsPeriodSettingComponent,
  },
  props: {
    popupParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeStep: 0,
      emptyTextType: {
        VMWARE: 'https://127.0.0.1:443/sdk',
        KVM: 'qemu+tcp://127.0.0.1/system',
        HYPERV: '127.0.0.1',
        RHEV: 'https://127.0.0.1/ovirt-engine/api/',
        XENSERVER: 'http://127.0.0.1',
      },
      formData: {
        virtualcenterGroupId: null,
        virtualcenterGroupName: null,
        hypervisorType: 'VMWARE',
        activeFlag: 'Y',
      },
      formRules: {
        // 가상화센터명
        virtualcenterGroupName: [
          {
            required: true,
            validator: this.validateVirtualcenterInfo,
            trigger: 'blur',
          },
        ],
        // 하이퍼바이저 타입
        hypervisorType: [
          {
            required: true,
            message: '필수 정보입니다.',
            trigger: 'change',
          },
        ],
        // RHEV 버전
        virtualcenterVersion: [
          {
            required: true,
            validator: this.validateRhev,
            trigger: 'change',
          },
        ],
        // RHEV 인증서 경로
        certificationPath: [
          {
            required: true,
            validator: this.validateRhev,
            trigger: 'blur',
          },
        ],
        // RHEV 인증서 암호
        certificationPassword: [
          {
            required: true,
            validator: this.validateRhev,
            trigger: 'blur',
          },
        ],
      },
      isUpdateFlag: false,
      scheduleData: {},
      hypervisorTypeList: [],
      modelingInfos: [
        {
          virtualcenterUrl: null,
          virtualcenterManagerId: null,
          virtualcenterPassword: null,
          virtualcenterVersion: null, // RHEV
          certificationPath: null, // RHEV
          certificationPassword: null, // RHEV
          sql_type: null,
        },
      ],
      rhevVersions: ['3.0', '4.0', '4.1', '4.2'],
      certificationFile: null,
    };
  },
  mounted() {
    BasicinfoSubAPI.getList('HYPERVISOR_TYPE').then((response) => {
      this.hypervisorTypeList = cloneDeep(response.data.data);
    });
  },
  methods: {
    open() {
      this.$nextTick(() => {
        if (this.popupParams.popupType === 'UPDATE') {
          const selectedModeling = this.popupParams.selectedRow;
          this.formData = cloneDeep(selectedModeling);
          this.modelingInfos = map(selectedModeling.virtualcenterList, (access) => ({
            sql_type: null,
            ...access,
          }));
          if (!isNil(this.popupParams.scheduleData) && !isNil(this.popupParams.scheduleData.scheduleId)) {
            this.isUpdateFlag = true;
            this.scheduleData = cloneDeep(this.popupParams.scheduleData);
            this.$refs.periodSettingCmp.setPeriodSettingData(this.scheduleData);
          }
        }
      });
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.init();
      this.$refs.slidingPopup.visible = false;
    },
    init() {
      this.activeStep = 0;
      this.isUpdateFlag = false;
      this.activeFlag = 'Y';
      this.scheduleData = {};
      this.formData = {
        virtualcenterGroupId: null,
        virtualcenterGroupName: null,
        hypervisorType: 'VMWARE',
        activeFlag: 'Y',
      };
      this.modelingInfos = [
        {
          virtualcenterUrl: null,
          virtualcenterManagerId: null,
          virtualcenterPassword: null,
          virtualcenterVersion: null, // RHEV
          certificationPath: null, // RHEV
          certificationPassword: null, // RHEV
          sql_type: null,
        },
      ];
      this.$refs.modelingForm.resetFields();
      this.$refs.periodSettingCmp.init();
    },
    moveStep(currentStep, targetStep) {
      if (currentStep === 0) {
        this.$refs.modelingForm
          .validate()
          .then((response) => {
            if (response) {
              this.activeStep = targetStep;
              if (!isEmpty(this.scheduleData)) {
                const scheduleData = this.scheduleData;
                this.$refs.periodSettingCmp.setPeriodSettingData(scheduleData);
              }
            }
          })
          .catch(() => {
            this.$message('데이터를 확인해 주십시오.');
          });
      } else {
        this.activeStep = targetStep;
      }
    },
    completeModeling() {
      const formData = this.formData;
      const modelingInfo = this.getModelingInfo();
      const scheduleData = this.$refs.periodSettingCmp.getPeriodSettingData();
      if (this.isUpdateFlag) {
        scheduleData.scheduleId = this.scheduleData.scheduleId;
      }
      scheduleData.scheduleContent = this.getScheduleContent(scheduleData);

      const params = {
        ...formData,
        ...scheduleData,
        virtualcenterList: modelingInfo,
      };

      const action = msgUtil.action.ADD;
      const target = '가상화 모델링';
      getRsaEncryptBulk(params.virtualcenterList, ['virtualcenterPassword', 'certificationPassword'])
        .then((encryptData) => {
          params.virtualcenterList = encryptData;
          if (formData.hypervisorType === 'RHEV') {
            // contentType 설정
            const formParams = new FormData();
            if (!isNil(this.certificationFile)) {
              formParams.append('fileName', this.certificationFile.fileName);
              formParams.append(this.certificationFile.fileName, this.certificationFile.fileInfo);
            }
            formParams.append('modelingInfo', JSON.stringify(params));

            DeviceRegistrationVmsAPI.insertRhevVirtualModeling(formParams)
              .then((response) => {
                if (response.data.success) {
                  this.$emit('re-load');
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.close();
                } else {
                  this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
                }
              })
              .catch(() => {
                this.$message('통신이 원할하지 않습니다.');
              });
          } else {
            DeviceRegistrationVmsAPI.insertVirtualModeling(params)
              .then((response) => {
                if (response.data.success) {
                  this.$emit('re-load');
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.close();
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              })
              .catch(() => {
                this.$message('통신이 원할하지 않습니다.');
              });
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    getScheduleContent(scheduleData) {
      let scheduleContent = null;
      const schedulePeriod = scheduleData.schedulePeriod;
      if (isEqual(schedulePeriod, 'N')) {
        scheduleContent = `${this.getDateFormatter(scheduleData.scheduleStarttime)} 에 수행`;
      } else if (isEqual(schedulePeriod, 'D')) {
        const scheduleIntervalHourArr = scheduleData.scheduleIntervalHour.split(',');
        let hourText = null;
        scheduleIntervalHourArr.forEach((string) => {
          if (isNil(hourText)) {
            hourText = `${TIME[string].label}시`;
          } else {
            hourText = `${hourText},${TIME[string].label}시`;
          }
        });
        scheduleContent = `${hourText} 에 수행`;
      } else if (isEqual(schedulePeriod, 'W')) {
        const scheduleIntervalDateArr = scheduleData.scheduleIntervalDate.split(',');
        let dateText = null;
        scheduleIntervalDateArr.forEach((string) => {
          if (isNil(dateText)) {
            dateText = `${WEEK[string - 1].label}`;
          } else {
            dateText = `${dateText},${WEEK[string - 1].label}`;
          }
        });
        scheduleContent = `${dateText} / ${TIME[scheduleData.scheduleHour].label}:${MINUTE[scheduleData.scheduleMinute].label} 에 수행`;
      } else if (isEqual(schedulePeriod, 'M')) {
        const scheduleIntervalMonthArr = scheduleData.scheduleIntervalMonth.split(',');
        let monthText = null;
        scheduleIntervalMonthArr.forEach((string) => {
          if (isNil(monthText)) {
            monthText = `${MONTH[string - 1].label}`;
          } else {
            monthText = `${monthText},${MONTH[string - 1].label}`;
          }
        });
        const scheduleIntervalDateArr = scheduleData.scheduleIntervalDate.split(',');
        let dateText = null;
        scheduleIntervalDateArr.forEach((string) => {
          if (isNil(dateText)) {
            dateText = `${isEqual(string, 'E') ? '마지막' : string}일`;
          } else {
            dateText = `${dateText},${isEqual(string, 'E') ? '마지막' : string}일`;
          }
        });
        scheduleContent = `${monthText} / ${dateText} / ${TIME[scheduleData.scheduleHour].label}:${MINUTE[scheduleData.scheduleMinute].label} 에 수행`;
      }
      return scheduleContent;
    },
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    validateVirtualcenterInfo(rule, value, callback) {
      const fieldName = rule.field;
      const index = rule.itemIndex;
      const formValue = fieldName === 'virtualcenterUrl' ? this.modelingInfos[index].virtualcenterUrl : value;
      if (isNil(formValue) || formValue === '') {
        return callback(new Error('필수 정보입니다.'));
      }
      // KVM일때 동일한 모델링 내에서 url 중복인지 체크
      if (isEqual(this.formData.hypervisorType, 'KVM') && fieldName === 'virtualcenterUrl') {
        const urlList = map(this.modelingInfos, (e) => e.virtualcenterUrl);
        const uniqUrlList = uniq(urlList);
        if (urlList.length !== uniqUrlList.length) {
          return callback(new Error('접속 정보가 중복됩니다.'));
        }
      }
      // DB에 이미 저장되어있는 데이터인지 중복 체크
      const params = {
        [fieldName]: formValue,
      };
      if (!isNil(this.formData.virtualcenterGroupId)) {
        params.virtualcenterGroupId = this.formData.virtualcenterGroupId;
      }
      if (fieldName === 'virtualcenterUrl') {
        params.virtualcenterId = this.modelingInfos[index].virtualcenterId;
      }
      DeviceRegistrationVmsAPI.checkVirtualcenterValidation(params).then((response) => {
        const isUniq = response.data.data;
        if (!isUniq && fieldName === 'virtualcenterGroupName') {
          callback(new Error('이미 사용 중인 이름입니다.'));
        } else if (!isUniq && fieldName === 'virtualcenterUrl') {
          callback(new Error('이미 사용 중인 접속정보입니다.'));
        }
        callback();
      });
      return true;
    },
    validateVirtualcenterLoginInfo(rule, value, callback) {
      const fieldName = rule.field;
      const index = rule.itemIndex;
      const formValue = this.modelingInfos[index][fieldName];
      if (isNil(formValue) || formValue === '') {
        return callback(new Error('필수 정보입니다.'));
      }
      return callback();
    },
    validateRhev(rule, value, callback) {
      const formValue = this.modelingInfos[0][rule.field];
      if (isEqual(this.formData.hypervisorType, 'RHEV')) {
        if (isNil(formValue) || formValue === '') {
          if (rule.required) {
            callback(new Error('필수 정보입니다.'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    changeCertificationPath(file) {
      if (file.size > 16 * 1024 * 1024) {
        this.$message('파일 사이즈가 16메가바이트를 초과하였습니다.');
      } else {
        // 비인가 확장자 파일인 경우 업로드 불가능
        if (isUnauthorizedFile(file)) {
          this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
          return;
        }
        this.certificationFile = {
          fileInfo: file.raw,
          fileName: file.name,
        };
        this.modelingInfos[0].certificationPath = file.name;
      }
      this.onInputChange(this.modelingInfos[0]);
    },
    addModelingInfo() {
      this.modelingInfos.push({
        virtualcenterUrl: null,
        virtualcenterManagerId: null,
        virtualcenterPassword: null,
        sql_type: 'INSERT',
      });
    },
    deleteModelingInfo(index) {
      if (this.isUpdateFlag) {
        this.modelingInfos[index].sql_type = 'DELETE';
      } else {
        this.modelingInfos.splice(index, 1);
      }
    },
    onInputChange(access) {
      access.sql_type = !isNil(access.virtualcenterId) ? 'UPDATE' : 'INSERT';
    },
    getModelingInfo() {
      this.modelingInfos.forEach((modeling, index) => {
        if (modeling.virtualcenterUrl === '' && modeling.virtualcenterManagerId === '' && modeling.virtualcenterPassword === '') {
          this.modelingInfos.splice(index, 1);
        }
      });
      return this.modelingInfos;
    },
    onHypervisorSelectChange() {
      this.modelingInfos = [
        {
          virtualcenterUrl: null,
          virtualcenterManagerId: null,
          virtualcenterPassword: null,
          virtualcenterVersion: null, // RHEV
          certificationPath: null, // RHEV
          certificationPassword: null, // RHEV
          sql_type: null,
        },
      ];
    },
  },
};
</script>

<style module></style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Virtual/popup/ModelingSettingPopup.vue